package br.com.vvrefeicoes.portal.domain.model

data class RmpRecord(
    val id: String,
    val rmpId: Long,
    val type: String? = null,
    val status: String? = null,
    val hrStatus: String? = null,
    val unitName: String? = null,
    val requesterName: String? = null,
    val requesterEmail: String? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null,
    val lastSyncedAt: String? = null,
    val presentInRmp: Boolean = true,
)

data class RmpSyncResult(
    val total: Int,
    val created: Int,
    val updated: Int,
    val failed: Int,
    val deleted: Int,
)

/** Anexo de um RMP do sistema antigo; só pode ser baixado depois de copiado para o S3 do portal. */
data class RmpRecordAttachment(
    val id: String,
    val field: String,
    val fileName: String,
    val status: RmpAttachmentStatus,
    val contentType: String? = null,
) {
    val available: Boolean
        get() = status == RmpAttachmentStatus.COPIADO
}

enum class RmpAttachmentStatus { PENDENTE, COPIADO, FALHOU, REMOVIDO }
